import { Box, Rating, Tooltip, Typography, alpha } from "@mui/material";
import { StarRounded, StarBorderRounded } from "@mui/icons-material";
import { IAvaliacaoPedido } from "../../interface/IAvaliacaoPedido";

const dataHoraBr = (valor?: string) => valor ? new Date(valor).toLocaleString("pt-BR") : "";

/**
 * Nota do cliente na listagem: compacta, porque divide espaço com mais doze
 * colunas. Sem avaliação a célula fica vazia em vez de inventar um zero.
 */
export const AvaliacaoPedidoResumo = ({ avaliacao }: { avaliacao?: IAvaliacaoPedido }) => {
    if (!avaliacao?.nota) {
        return <Typography variant="body2" color="text.disabled">-</Typography>;
    }

    const titulo = [
        `${avaliacao.nota} de 5`,
        avaliacao.comentario ? `“${avaliacao.comentario}”` : null,
        avaliacao.dataHoraResposta ? dataHoraBr(avaliacao.dataHoraResposta) : null,
    ].filter(Boolean).join(" · ");

    return (
        <Tooltip title={titulo}>
            <Box sx={{ display: "inline-flex", alignItems: "center", gap: 0.5, whiteSpace: "nowrap" }}>
                <StarRounded sx={{ fontSize: "1rem", color: "warning.main" }} />
                <Typography variant="body2" fontWeight={600}>{avaliacao.nota}</Typography>
                {!!avaliacao.comentario && (
                    <Typography variant="caption" color="text.secondary">💬</Typography>
                )}
            </Box>
        </Tooltip>
    );
};

/** Bloco da avaliação no detalhe do pedido, com a nota e o que o cliente escreveu. */
export const AvaliacaoPedidoDetalhe = ({ avaliacao }: { avaliacao?: IAvaliacaoPedido }) => {
    if (!avaliacao) {
        return null;
    }

    const respondida = !!avaliacao.nota;

    return (
        <Box
            sx={{
                p: 2,
                borderRadius: 2,
                backgroundColor: theme => alpha(theme.palette.text.primary, 0.03),
                border: theme => `1px solid ${alpha(theme.palette.text.primary, 0.08)}`,
            }}
        >
            <Typography variant="subtitle2" fontWeight={700} sx={{ mb: 1 }}>
                Avaliação do cliente
            </Typography>

            {respondida ? (
                <>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                        <Rating
                            value={avaliacao.nota}
                            readOnly
                            icon={<StarRounded fontSize="inherit" />}
                            emptyIcon={<StarBorderRounded fontSize="inherit" />}
                        />
                        <Typography variant="body2" fontWeight={600}>
                            {avaliacao.nota} de 5
                        </Typography>
                    </Box>

                    {!!avaliacao.comentario && (
                        <Typography
                            variant="body2"
                            sx={{ mt: 1.25, fontStyle: "italic", color: "text.secondary" }}
                        >
                            “{avaliacao.comentario}”
                        </Typography>
                    )}

                    {!!avaliacao.dataHoraResposta && (
                        <Typography variant="caption" color="text.secondary" sx={{ display: "block", mt: 1 }}>
                            Respondida em {dataHoraBr(avaliacao.dataHoraResposta)}
                        </Typography>
                    )}
                </>
            ) : (
                <Typography variant="body2" color="text.secondary">
                    Convite enviado{avaliacao.dataHoraSolicitacao ? ` em ${dataHoraBr(avaliacao.dataHoraSolicitacao)}` : ""} — o cliente ainda não respondeu.
                </Typography>
            )}
        </Box>
    );
};
